module.exports = __webpack_public_path__ + "img/GERA_2020_AUT_Karte.png";